import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** White card with a header bar (title, then filters or actions), as the tables of 06, 07, 09 to 14. */
export function SectionCard({ title, toolbar, children, footer, className }: { title?: ReactNode; toolbar?: ReactNode; children: ReactNode; footer?: ReactNode; className?: string }) {
  return (
    <section className={cn('flex min-w-0 flex-col rounded-card border border-border bg-card', className)}>
      {(title || toolbar) && (
        <div className="flex flex-wrap items-center gap-3 border-b border-border px-5 py-3.5">
          {title && <h2 className="m-0 mr-2 text-base font-bold">{title}</h2>}
          {toolbar}
        </div>
      )}
      {children}
      {footer}
    </section>
  );
}

/** Round order badge (06, 09). */
export function OrderBadge({ order }: { order: number | null }) {
  return (
    <span
      aria-label={order === null ? 'Sans ordre' : `Ordre ${order}`}
      className="inline-flex size-7 items-center justify-center rounded-full bg-muted text-[13px] font-bold tabular-nums text-foreground"
    >
      {order ?? '—'}
    </span>
  );
}
